import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FilterTitleComponent } from '../../common/filter-title/filter-title.component';
import { Filter } from '../../models/filter-models';
import { FilterService } from '../../services/filter.service';
import { SelectGearTierComponent } from '../../common/select/select-gear-tier/select-gear-tier.component';
import { EquipmentTierPickerComponent } from '../../common/equipment-tier-picker/equipment-tier-picker.component';
import { AutocompleteComponent } from '../../common/autocomplete/autocomplete.component';
import { BaseComponent } from '../../common/base.component';
import { ItemDataService } from '../../services/item-data.service';
import { ActiveRules } from '../../services/filter-generator.service';
import { Rarity } from '../../models/enums';
import { EquipmentType } from "../../models/equipment-type.enum";

@Component({
  selector: 'app-influenced-gear-filters-poe1',
  imports: [FormsModule, FilterTitleComponent, SelectGearTierComponent, EquipmentTierPickerComponent, AutocompleteComponent],
  templateUrl: './influenced-gear-filters-poe1.component.html',
  styleUrl: './influenced-gear-filters-poe1.component.scss'
})
export class InfluencedGearFiltersPoe1Component extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeRules!: ActiveRules;

  influences: { name: string, image: string }[] = [];
  syndicateMembers!: { name: string, image?: string }[];

  EquipmentType = EquipmentType;
  Rarity = Rarity;

  constructor(
    private filterService: FilterService,
    private itemDataService: ItemDataService
  ) {
    super();
    this.influences = this.itemDataService.getInfluences();
    this.syndicateMembers = this.itemDataService.getAllSyndicateMembers().filter(m => m.name !== 'All');
  }

  toggleShowInfluencedGear = () => { this.filter.showInfluencedGear = !this.filter.showInfluencedGear; this.updateFilter(); }
  toggleShowFracturedGear = () => { this.filter.showFracturedGear = !this.filter.showFracturedGear; this.updateFilter(); }
  toggleShowSynthesisedGear = () => { this.filter.showSynthesisedGear = !this.filter.showSynthesisedGear; this.updateFilter(); }
  toggleShowVeiledGear = () => { this.filter.showVeiledGear = !this.filter.showVeiledGear; this.updateFilter(); }
  toggleShowMemoryStrandGear = () => { this.filter.showMemoryStrandGear = !this.filter.showMemoryStrandGear; this.updateFilter(); }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
